import { Environment } from '@react-three/drei';
import CameraRig from './CameraRig';
import DebugControls from './DebugControls';
import PostEffects from './PostEffects';
import ExtrudedRingMesh from './ExtrudedRingMesh';
import useStore from '../../store/useStore';

const isDebug = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('debug');

export default function RingScene() {
    return (
        <>
            <SceneEnvironment />

            {/* DXF-extruded ring from selected profile */}
            <group rotation={[Math.PI * 0.35, Math.PI * 0.1, Math.PI * 0.08]}>
                <ExtrudedRingMesh />
            </group>

            {/* In debug mode: free OrbitControls; otherwise scroll-driven CameraRig */}
            {isDebug ? <DebugControls /> : <CameraRig />}

            {/* Post-processing (bloom etc.) */}
            <PostEffects />
        </>
    );
}

/** Renders the HDR envmap from hd_conf (same file, copied to public/3d/hdri/).
 * `environmentIntensity` is the scene-level IBL multiplier — the effective control
 * for dimming all PBR metals in dark mode (per-material envMapIntensity is overridden by this).
 */
function SceneEnvironment() {
    const isDark = useStore((s) => s.isDark);
    return (
        <Environment
            files="/3d/hdri/envmap.hdr"
            background={false}
            environmentIntensity={isDark ? 0.15 : 1.0}
        />
    );
}
